<template>
  <div class="footer-bar">
    <van-tabbar route>
      <van-tabbar-item to="/questionnaire">
        <van-image
          width="35"
          height="35"
          :src="$route.path==='/questionnaire' ? wenjuan :wenjuanhui"
        />
        <div class="text-color one" :class="{'orange-color':$route.path==='/questionnaire'}">{{$t("bottomBar.wenjuan")}}</div>
        <div class="btm-tab" :class="{'btm-tab-active': $route.path==='/questionnaire'}"></div>
      </van-tabbar-item>
      <van-tabbar-item to="/exchange">
        <van-image
          width="25"
          height="25"
          :src="$route.path==='/exchange' ? duihuan:duihuanhui"
        />
        <div class="text-color" style="margin-top: 0.09rem;"
             :class="{'orange-color':$route.path==='/exchange'}">{{$t("bottomBar.duihuan")}}</div>
        <div class="btm-tab" :class="{'btm-tab-active': $route.path==='/exchange'}"></div>
      </van-tabbar-item>
      <van-tabbar-item to="/helpEarn">
        <van-image
          width="25"
          height="25"
          :src="$route.path==='/helpEarn' ? bangzhuan:bangzhuanhui"
        />
        <div class="text-color" style="margin-top: 0.08rem;" :class="{'orange-color':$route.path==='/helpEarn'}">{{$t("bottomBar.bangzhuan")}}</div>
        <div class="btm-tab" :class="{'btm-tab-active': $route.path==='/helpEarn'}"></div>
      </van-tabbar-item>
      <van-tabbar-item to="/mine">
        <van-image
          width="30"
          height="30"
          :src="$route.path==='/mine' ? wode:wodehui"
        />
        <div class="text-color one" :class="{'orange-color':$route.path==='/mine'}">{{$t("bottomBar.wode")}}</div>
        <div class="btm-tab" :class="{'btm-tab-active': $route.path==='/mine'}"></div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import wenjuan from '@/assets/img/问卷.png'
  import wenjuanhui from '@/assets/img/问卷-灰.png'
  import duihuan from '@/assets/img/兑换.png'
  import duihuanhui from '@/assets/img/兑换-灰.png'
  import bangzhuan from '@/assets/img/帮赚.png'
  import bangzhuanhui from '@/assets/img/帮赚-灰.png'
  import wode from '@/assets/img/我的.png'
  import wodehui from '@/assets/img/我的-灰.png'
  export default {
    name: 'footerBar',
    components: {
    },
    data () {
      return {
        wenjuan: wenjuan,
        wenjuanhui:wenjuanhui,
        duihuan:duihuan,
        duihuanhui:duihuanhui,
        bangzhuan:bangzhuan,
        bangzhuanhui:bangzhuanhui,
        wode:wode,
        wodehui:wodehui
      }
    },
    methods: {
      onChange(index) {

      },
    },
    mounted () {
    },
  }
</script>

<style lang="stylus" scoped>
@media screen and (min-width: 768px){
  /deep/ .van-tabbar--fixed{
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 768PX;
  }
}
  /deep/.footer-bar{
    .van-hairline--top-bottom{
      height: 60px;
      .van-tabbar-item{
        text-align: center;
        position: relative;
        .van-image{
          margin-top: 10px
          width 10px;
          height: 10px;
        }
        .text-color{
          font-size: .3rem;
          color: gray;
          font-weight: bold;
          margin-top: 5px;
        }
        .one{
          margin-top: 0;
        }
        .btm-tab{
          width: .6rem;
          height: .2rem;
        }

        .btm-tab-active{
          border-radius: 10px;
          background: #D1DDFC;
          position relative;
          left:50%;
          transform: translateX(-50%)
        }
        .orange-color{
          color: #F57E3D;
        }
      }
    }

    // @media only screen and (max-width : 768px) {
    //   .van-hairline--top-bottom{
    //     width: 768px !important;
    //   }
    // }
  }
</style>
<style scoped>
.van-tabbar-item {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/common/footer-bar/index.vue